import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ConversationsFilter from './ConversationsFilter';

function ConversationsToolbar({
 activeFilters, searchValue = null, onSearchChange, onFilterChange, isMedia = true,
}) {
  const [filtersVisible, setFiltersVisible] = useState(false);
  // Stale role filters (e.g. set when the user was media) are inert for promoters,
  // so they shouldn't keep the toolbar in its expanded "active filters" state.
  const activeRole = isMedia ? activeFilters?.role : null;
  const hasActiveFilters = activeRole || activeFilters?.status || activeFilters?.posts;

  return (
    <div
      className={classnames(
        'd-flex flex-wrap gap-2 align-items-center py-4 border-top border-bottom border-neutral-20',
        filtersVisible || hasActiveFilters ? 'pb-3' : 'pb-4',
      )}
      style={{ paddingInline: 32 }}
    >
      <div className="position-relative flex-grow-1">
        <i className="fa-solid fa-search position-absolute top-50 translate-middle-y ms-3 text-muted" />
        <input
          aria-label="Search"
          className="form-control ps-5"
          value={searchValue ?? ''}
          onChange={onSearchChange}
          placeholder="Search"
          type="search"
          style={{ height: 40 }}
        />
      </div>

      <ConversationsFilter
        activeFilters={activeFilters}
        filtersVisible={filtersVisible}
        onToggleFilters={() => setFiltersVisible(!filtersVisible)}
        onFilterChange={onFilterChange}
        isMedia={isMedia}
      />
    </div>
  );
}

ConversationsToolbar.propTypes = {
  activeFilters: PropTypes.shape({
    role: PropTypes.string,
    status: PropTypes.string,
    posts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  isMedia: PropTypes.bool,
};

export default ConversationsToolbar;
